import { timeout as w } from "../../../reactive/utils.js";
import { UrlsAPI as l } from "../../urls/index.js";
typeof window < "u" && (window.dataLayer = window.dataLayer || []);
function u(...i) {
  var m;
  (m = window == null ? void 0 : window.dataLayer) == null || m.push(arguments);
}
var p;
((i) => {
  const m = (e) => `https://www.googletagmanager.com/gtag/js?id=${e}`;
  async function g() {
    if (!window)
      return null;
    const [e] = Object.keys(window.google_tag_manager || []).filter((n) => n.substring(0, 2) === "G-");
    if (!e)
      return null;
    try {
      const n = await w(100, new Promise((o) => {
        u("get", e, "session_id", o);
      })), r = await w(100, new Promise((o) => {
        u("get", e, "client_id", o);
      }));
      return {
        sessionId: n,
        clientId: r
      };
    } catch {
      return null;
    }
  }
  i.getSessionValues = g;
  async function f(e, n) {
    let r = new URL(e.toString());
    const o = await g(), a = new URLSearchParams(window.location.search);
    if (a.has("utm_source")) {
      const s = ["utm_source", "utm_medium", "utm_id", "utm_campaign", "utm_content", "utm_term"].reduce((c, t) => {
        const d = a.get(t);
        return d === null ? c : {
          ...c,
          [t]: d
        };
      }, {});
      r = new URL(l.replaceParameters(r, s));
    } else n && (r = new URL(l.replaceParameters(r, {
      utm_source: n,
      utm_medium: "referral"
    })));
    return o === null ? r : l.replaceParameters(r, {
      gsid: o.sessionId,
      gcid: o.clientId
    });
  }
  i.appendAnalyticsToUrl = f;
  async function y(e) {
    var c;
    if (typeof window > "u" || (c = window.google_tag_manager) != null && c[e])
      return;
    const n = "cheerfy-gtm-head", r = "cheerfy-gtm-body", o = document.querySelector(`script[id="${n}"]`), a = document.querySelector(`#${r}`);
    if (!o) {
      const t = document.createElement("script");
      t.id = n, t.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${e}');`, document.head.appendChild(t);
    }
    if (!a) {
      const t = document.createElement("noscript");
      t.id = r, t.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${e}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`, document.body.insertBefore(t, document.body.firstChild);
    }
    const s = document.querySelector('script[src*="googletagmanager.com/gtm.js"]');
    s && await new Promise((t) => {
      var d;
      if ((d = window.google_tag_manager) != null && d[e]) {
        t();
        return;
      }
      s.addEventListener("load", () => t(), { once: !0 }), s.addEventListener("error", () => t(), { once: !0 }), setTimeout(t, 1e4);
    });
  }
  i.loadGTM = y;
  async function h(e) {
    if (typeof window > "u")
      return Promise.resolve();
    const n = m(e);
    return document.querySelector(`script[src="${n}"]`) ? Promise.resolve() : new Promise((o) => {
      const a = document.createElement("script");
      a.onload = () => {
        u("js", /* @__PURE__ */ new Date()), u("config", e), o(), window.dispatchEvent(new Event("GTMLoaded"));
      }, a.src = n, document.head.appendChild(a);
    });
  }
  i.loadGa = h;
})(p || (p = {}));
export {
  p as GoogleAnalytics
};
//# sourceMappingURL=index.js.map
